<template>
  <div
    :style="style"
    class="bg-color pt-6 px-6"
    role="banner"
  >
    <div class="flex items-center">
      <div class="flex-1">
        <h3 class="font-bold text-2xl sm:text-3xl text:color">{{ title }}</h3>
      </div>
      <div v-if="phone" class="ml-auto">
        <button-link
          :href="`tel:${phone}`"
          :target="target"
          class="flex items-center justify-center px-4 py-2 ml-auto border-gray-500"
          aria-label="Call location phone number"
        >
          <svg-phone
            width="24"
            height="24"
            class="mr-1 flex-shrink-0"
            aria-hidden="true"
            role="img"
          ></svg-phone>
          <span class="text-sm font-bold uppercase" aria-label="Phone number">
            {{ phone }}
          </span>
        </button-link>
      </div>
    </div>
  </div>
</template>

<script>
import SvgPhone from "@/components/Svg/SvgPhone.vue";
import ButtonLink from "@/components/Button/ButtonLink.vue";

export default {
  components: {
    SvgPhone,
    ButtonLink,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    title() {
      return this.$store.state?.config?.samedayTitle || "Same-Day Appointment";
    },
    phone() {
      if (!this.form) return;
      return this.form?.location?.contact_no;
    },
    target() {
      const isIframe = this.$store.state.config.iframeMode;
      return isIframe ? "_parent" : "_self";
    },
    style() {
      const colors = this.$store.state.config.colors;
      return {
        "--color": colors.headerColor,
        "--bg-color": colors.containerBackground || "#FFFFFF",
      };
    },
  },
};
</script>

<style scoped>
.text\:color {
  color: var(--color);
}
.bg-color {
  background-color: var(--bg-color);
}
</style>